<template>
  <div class="change-email-address">
    <div class="change-email-address__container">
      <button class="change-email-address__close" @click="toggleComponent(false)">
        <i-svg icon="icon_close" />
      </button>
      <h2 class="change-email-address__title">
        {{ $t('verify_acc_details_pop_up_title') }}
      </h2>
      <div class="change-email-address__form">
        <div class="change-email-address__input">
          <h3>{{ $t('verify_acc_details_pop_up_current_email') }}</h3>
          <base-input
            :model-value="store.userEmail"
            disabled
          />
        </div>
        <div class="change-email-address__input">
          <h3>{{ $t('verify_acc_details_pop_up_new_email') }}</h3>
          <base-input
            id="email"
            v-model="newEmail"
            type="email"
            :error="showInputError"
            :placeholder="$t('verify_acc_details_pop_up_new_email_name')"
          />
        </div>
      </div>
      <base-button
        :is-disabled="isDisabledButton"
        type="red"
        with-shadow
        rounded="full"
        :is-loading="isLoading"
        class="change-email-address__cta"
        @click="validateEmail"
      >
        {{ $t('verify_acc_details_pop_up_submit_button') }}
      </base-button>
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['action']);
const { toggleComponent } = useModals();
const store = useKegelStore();
const API = useKegelApi();
const { $db } = useNuxtApp();
const { openError } = useAllModals();
const { checkEmailFormat, useCheckDomainExists } = useEmail();
const newEmail = ref('');
const showInputError = ref(false);
const isLoading = ref(false);

async function validateEmail() {
  isLoading.value = true;
  const isValid = await useCheckDomainExists(newEmail.value);

  if (isValid) {
    await changeEmail();
  } else {
    openError({ content: 'verify_acc_details_pop_up_wrong_email_message' });
    showInputError.value = true;
    isLoading.value = false;
  }
}

async function changeEmail() {
  const payload = {
    new_email: newEmail.value,
    previous_email: store.userEmail,
    web_user_uuid: store.userUuid,
  };

  const isValid = await API.changeUserEmail(payload);

  if (isValid) {
    store.userEmail = newEmail.value;
    $db.setItem('user_email', String(newEmail.value));
    toggleComponent();
    emit('action');
  } else {
    openError({ content: 'mail_error_message' });
    showInputError.value = true;
  }
  isLoading.value = false;
}

const isDisabledButton = computed(() => {
  return !checkEmailFormat(newEmail.value);
});

watch(newEmail, () => {
  showInputError.value = false;
});
</script>

<style lang="scss">
.change-email-address {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;

  &__container {
    position: relative;
    background: $white;
    padding: 25px 32px 64px;
    max-width: 600px;
    margin: 0 auto;
    border-radius: 18px 18px 0px 0px;
  }

  &__close {
    position: absolute;
    right: 8px;
    top: 8px;
    border: none;
    background: transparent;
    padding: 0;
  }

  &__title {
    color: $text-color;
    text-align: center;
    font-family: $primary-fonts;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 135%; /* 27px */
    margin-bottom: 24px;
  }

  &__form {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__input {
    & h3 {
      color: $text-color;
      font-family: $primary-fonts;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 135%; /* 18.9px */
      margin-bottom: 8px;
    }
  }

  &__cta {
    margin-top: 32px !important;
    padding: 18px 20px !important;
  }
}
</style>
